import { getCumulativeSum, isValidNewDynamicPlan } from "../utils/utils";
import {
  fetchInductSortTargetData,
  fetchIsShiftPlanEnabledFeatureFlag,
  fetchPVAData,
  fetchPVADataOutbound,
  fetchStowWipIntervalData,
  fetchTargetData,
  fetchWipTargetData,
  getLatestDynamicShiftPlan,
  getMasterPlan,
} from "../network/OverviewNetworkAPI";
import { OUTBOUND } from "../utils/Constants";

export const PVAOverviewReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_PVA_DATA":
      const { filter, dispatcher, processName, baseUrl } = action.data;
      if (processName !== OUTBOUND) {
        fetchPVAData(filter, dispatcher);
        fetchTargetData(filter, "target", dispatcher);
        fetchInductSortTargetData(filter, dispatcher);
        fetchWipTargetData("station-target", dispatcher);
        fetchStowWipIntervalData(filter, dispatcher);
      } else {
        fetchPVADataOutbound(filter, dispatcher, baseUrl);
        fetchInductSortTargetData(filter, dispatcher);
      }
      return state;
    case "LOAD_DYNAMIC_PLAN_DATA":
      getLatestDynamicShiftPlan(action.data.dispatcher);
      getMasterPlan(action.data.dispatcher);
      return state;
    case "LOAD_PLANNED_HC_DATA":
      fetchIsShiftPlanEnabledFeatureFlag(action.data.dispatcher);
      return state;
    case "RECEIVE_TARGET_DATA":
      if (action.data && action.data.targetMap) {
        return {
          ...state,
          targetData: {
            ...state.targetData,
            ...action.data,
            ...action.data.targetMap,
          },
        };
      }
      return state;
    case "RECEIVE_INDUCT_SORT_TARGET_DATA":
      return {
        ...state,
        targetData: {
          ...state.targetData,
          ...action.data,
        },
      };
    case "RECEIVE_PVA_DATA":
      const overviewData = action.data.flowPVAData;
      let cumulativeData = overviewData["60"].map((processData) =>
        getCumulativeSum(processData),
      );
      let cumulativeData15mins = overviewData["15"].map((processData) =>
        getCumulativeSum(processData),
      );
      overviewData["cumulative_15"] = cumulativeData15mins;
      overviewData["cumulative"] = cumulativeData;
      return {
        ...state,
        overviewData: {
          ...state.overviewData,
          ...action.data,
        },
      };
    case "RECEIVE_WIP_INTERVAL_DATA":
      return {
        ...state,
        wip: {
          ...state.wip,
          ...action.data,
        },
      };

    case "RECEIVE_OUTBOUND_PVA_DATA":
      const outboundPVA = action.data.flowPVAData;
      let outboundCumulativePVA = outboundPVA["60"].map((processData) =>
        getCumulativeSum(processData),
      );
      let outboundCumulativeData15Min = outboundPVA["15"].map((processData) =>
        getCumulativeSum(processData),
      );
      outboundPVA["cumulative_15"] = outboundCumulativeData15Min;
      outboundPVA["cumulative"] = outboundCumulativePVA;

      return {
        ...state,
        pick: {
          ...state.pick,
          flowPVAData: {
            60: outboundPVA["60"][0],
            30: outboundPVA["30"][0],
            15: outboundPVA["15"][0],
            cumulative_15: outboundPVA["cumulative_15"][0],
            cumulative: outboundPVA["cumulative"][0],
          },
        },
        stage: {
          ...state.stage,
          flowPVAData: {
            60: outboundPVA["60"][1],
            30: outboundPVA["30"][1],
            15: outboundPVA["15"][1],
            cumulative_15: outboundPVA["cumulative_15"][1],
            cumulative: outboundPVA["cumulative"][1],
          },
        },
      };
    case "RECEIVE_PLANNED_HEADCOUNT_DATA":
      if (action.data) {
        return { ...state, shiftPlans: action.data };
      }
      return state;
    case "RECEIVE_PPH_DATA":
      if (action.data) {
        return { ...state, pphData: action.data };
      }
      return state;
    case "CHANGE_GRANULARITY":
      return {
        ...state,
        pvaTableData: {
          ...state.pvaTableData,
          granularity: action.data.granularity,
        },
      };

    case "SET_PVA_GRAPH_PROCESS":
      return {
        ...state,
        pvaGraphData: {
          ...state.pvaGraphData,
          processName: action.data.processName,
        },
      };
    case "SET_PVA_GRAPH_GRANULARITY":
      return {
        ...state,
        pvaGraphData: {
          ...state.pvaGraphData,
          granularity: action.data.granularity,
        },
      };

    case "RECEIVE_TPH":
      return { ...state, performance: action.data };

    case "RECEIVE_PPA":
      return { ...state, processPathAggregateData: action.data };

    case "RECEIVE_INBOUND_DATA":
      const inBoundData = action.data.flowPVAData;
      let cumulativeInboundData = inBoundData["60"].map((processData) =>
        getCumulativeSum(processData),
      );
      let cumulativeInboundData15mins = inBoundData["15"].map((processData) =>
        getCumulativeSum(processData),
      );
      inBoundData["cumulative"] = cumulativeInboundData;
      inBoundData["cumulative_15"] = cumulativeInboundData15mins;
      return {
        ...state,
        inbound: {
          ...state.inbound,
          ...action.data,
        },
      };

    case "RECEIVE_WIP_DATA":
      if (
        action.data &&
        Object.keys(action.data).length > 0 &&
        action.data[0].targetMap
      ) {
        return {
          ...state,
          wipTargetData: {
            ...state.wipTargetData,
            ...action.data[0].targetMap,
          },
        };
      }
      return state;

    case "RECEIVE_LATEST_DYNAMIC_SHIFT_PLAN":
      if (isValidNewDynamicPlan(state.dynamicShiftPlans.latest, action.data)) {
        return {
          ...state,
          dynamicShiftPlans: {
            ...state.dynamicShiftPlans,
            latest: action.data,
          },
        };
      }
      return state;

    case "RECEIVE_MASTER_PLAN":
      if (action.data) {
        return {
          ...state,
          dynamicShiftPlans: {
            ...state.dynamicShiftPlans,
            master: action.data,
          },
        };
      }
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/overview/reducers/PVAOverviewReducer.js